import { Component, OnInit, OnDestroy } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Location } from "@angular/common";
import { TamasAlunoService } from "../tamas-aluno.service";
import { AlertaSimplesDialog } from "../alerta-simples";
import { AlertaInputDialog } from "../alerta-input";
import { AlertaConfirmDialog } from "../alerta-confirm";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import * as moment from "moment";

@Component({
  selector: "app-dashboard-paciente",
  templateUrl: "./dashboard-paciente.component.html",
  styleUrls: ["./dashboard-paciente.component.css"],
})
export class DashboardPacienteComponent implements OnInit {
  hideCL: boolean = false;
  meuNome: any = "";
  meuNick: any = "";
  dataNascimento: any = "";
  altura: any = "";
  peso: any = "";
  meuLocal: any = "";
  minhaFoto: any = "";
  meuCelular: any = "";
  minhaFrase: any = "";
  urlFoto: any = "";
  idPaciente: any = "";
  arrAlimentar: any[] = [];
  arrTreinos: any[] = [];
  arrAvaliacoes: any[] = [];
  pacienteDT: any = "";
  pendente: boolean = true;
  constructor(
    private route: ActivatedRoute,
    private _location: Location,
    public router: Router,
    public tmaService: TamasAlunoService,
    public dialog: MatDialog
  ) {}

  ngOnInit() {
    this.idPaciente = this.route.snapshot.paramMap.get("idpaciente");
    this.buscarDadosPaciente();
    this.tmaService.eventoFS(true);
    //
  }

  ngOnDestroy() {
    console.log("destroy");
    this.tmaService.eventoFS(false);
  }

  buscarDadosPaciente(): void {
    this.hideCL = false;
    var dadosIn =
      "email=" +
      this.tmaService.hcEmail +
      "&senha=" +
      this.tmaService.hcSenha +
      "&idpaciente=" +
      this.idPaciente;
    this.tmaService.getInfoPaciente(dadosIn).subscribe((qRes) => {
      console.log(qRes);
      if (qRes["res"] == "ok") {
        this.pendente = false;
        this.urlFoto =
          this.tmaService.urlRepositorioS3 + "/users-profile-picture/";
        this.meuNome = qRes["objPerfil"].nome;
        this.meuNick = qRes["objPerfil"].nickname;
        this.dataNascimento = moment(qRes["objPerfil"].dataN).format(
          "DD/MM/YYYY"
        );
        this.pacienteDT = moment(qRes["pacienteData"]).format("DD/MM/YYYY");
        //this.altura = qRes['objPerfil'].altura.toFixed(2);
        this.altura = qRes["objPerfil"].altura;
        this.peso = qRes["objPerfil"].peso;
        this.meuLocal = qRes["objPerfil"].cidade + "/" + qRes["objPerfil"].uf;
        this.minhaFoto = qRes["objPerfil"].fotoPerfil;
        this.meuCelular = qRes["objPerfil"].celular;
        this.minhaFrase = qRes["objPerfil"].frasebio;

        //array alimentar
        this.arrAlimentar = qRes["objAlimentar"];
        this.arrAlimentar.forEach((element) => {
          element.data = moment(element.data).format("DD/MM/YYYY");
          element.dataini = moment(element.dataini).format("DD/MM/YYYY");
          element.dataretorno = moment(element.dataretorno).format(
            "DD/MM/YYYY"
          );
        });

        this.arrTreinos = qRes["objMacros"];
        this.arrAvaliacoes = qRes["objAvaliacoes"];

        this.arrAvaliacoes.forEach((element) => {
          element.data = moment(element.data).format("DD/MM/YYYY");
        });
      } else {
        //algo errado
        if (qRes["res"] == "pendente") {
          this.pendente = true;
        } else {
          this.voltar();
        }
      }
      this.hideCL = true;
    });
  }

  buscarInfoUser(qUsuario: any): void {
    //server side
    this.hideCL = false;
    var dadosIn =
      "nomeusuario=" +
      qUsuario +
      "&email=" +
      this.tmaService.hcEmail +
      "&senha=" +
      this.tmaService.hcSenha;
    this.tmaService.listarPerfilP(dadosIn).subscribe((qRes) => {
      console.log(qRes);
      if (qRes["res"] == "done") {
        this.urlFoto =
          this.tmaService.urlRepositorioS3 + "/users-profile-picture/";
        this.meuNome = qRes["objPerfil"].nome;
        this.meuNick = qRes["objPerfil"].nickname;
        this.dataNascimento = moment(qRes["objPerfil"].dataN).format(
          "DD/MM/YYYY"
        );
        //this.altura = qRes['objPerfil'].altura.toFixed(2);
        this.altura = qRes["objPerfil"].altura;
        this.peso = qRes["objPerfil"].peso;
        this.meuLocal = qRes["objPerfil"].cidade + "/" + qRes["objPerfil"].uf;
        this.minhaFoto = qRes["objPerfil"].fotoPerfil;
        this.meuCelular = qRes["objPerfil"].celular;
        this.minhaFrase = qRes["objPerfil"].frasebio;
      } else {
        //algo errado
      }
      this.hideCL = true;
    });
  }
  goEdit(tipoP: any): void {
    if (tipoP == "modalidades") {
      this.tmaService.gUrlAnterior = "me/perfil";
      this.router.navigate(["/" + this.tmaService.hcNomeUsuario + "/" + tipoP]);
    } else if (tipoP == "conquistas") {
      this.tmaService.gUrlAnterior = "me/perfil";
      this.router.navigate(["/" + this.tmaService.hcNomeUsuario + "/" + tipoP]);
    } else if (tipoP == "localizacao") {
      this.tmaService.gUrlAnterior = "me/perfil";
      this.router.navigate(["/me/perfil/local"]);
    } else if (tipoP == "foto") {
      this.tmaService.gUrlAnterior = "me/perfil";
      this.router.navigate(["/me/perfil/foto"]);
    } else if (tipoP == "locais") {
      this.tmaService.gUrlAnterior = "me/perfil";
      this.router.navigate(["/" + this.tmaService.hcNomeUsuario + "/" + tipoP]);
    } else if (tipoP == "profissionais") {
      this.tmaService.gUrlAnterior = "me/perfil";
      this.router.navigate(["/" + this.tmaService.hcNomeUsuario + "/" + tipoP]);
    } else {
      const atendimentOffDialog = this.dialog.open(AlertaSimplesDialog, {
        disableClose: true,
        data: { textoAlerta: "Opss...", iconAlerta: "warning" },
      });
    }
  }

  goPerfil(nomeUser: any): void {
    this.tmaService.gUrlAnterior = this.router.url;
    this.router.navigate(["/" + nomeUser]);
  }

  goSettings(): void {
    console.log("settings");
    this.tmaService.gUrlAnterior = "me/perfil";
    this.router.navigate(["/me/settings"]);
  }
  logout(): void {
    const avisoIC = this.dialog.open(AlertaConfirmDialog, {
      // width: '250px',
      disableClose: true,
      data: {
        tituloAlerta: "Aviso",
        textoAlerta: "Desja efetuar o logout?",
        textoCancel: "Não",
        textoConfirm: "Sim",
      },
    });
    avisoIC.afterClosed().subscribe((result) => {
      console.log(result);
      if (result == true) {
        this.tmaService.hcEmail = "";
        this.tmaService.hcSenha = "";
        this.tmaService.hcNomeUsuario = "";
        this.tmaService.logado = false;
        localStorage.removeItem("tmsDadosCliente");
        this.router.navigate(["/autenticar"]);
      }
    });
    console.log("sair");
  }

  addAvaliacao(): void {
    //server side criar uma nova avaliação como nome "sem titulo" e redirecionar o id

    const avisoIC = this.dialog.open(AlertaConfirmDialog, {
      // width: '250px',
      disableClose: true,
      data: {
        tituloAlerta: "Aviso",
        textoAlerta: "Deseja criar uma nova avaliação?",
        textoCancel: "Não",
        textoConfirm: "Sim",
      },
    });
    avisoIC.afterClosed().subscribe((result) => {
      console.log(result);
      if (result == true) {
        this.hideCL = false;
        //criar no servidor
        let customParams = {
          //lista: localStorage.getItem('turboCart'),
          email: this.tmaService.hcEmail,
          senha: this.tmaService.hcSenha,
          idpaciente: this.idPaciente,
        };
        //var dadosU = 'email=' + this.tmaService.hcEmail + '&senha=' + this.tmaService.hcSenha + '&idpaciente=' + this.idPaciente;
        this.tmaService.criarAvaliacao(customParams).subscribe((qRes) => {
          this.hideCL = true;
          if (qRes["res"] == "ok") {
            this.router.navigate([
              "/dashboard/paciente/" +
                this.idPaciente +
                "/avaliacao/" +
                qRes["idavaliacao"],
            ]);
          } else {
            const erroCriar = this.dialog.open(AlertaSimplesDialog, {
              disableClose: true,
              data: {
                textoAlerta:
                  "Ocorreu um erro ao criar nova avaliação. Tente novamente",
                iconAlerta: "warning",
              },
            });
          }
        });
      }
    });
  }

  excluirMacro(idMacro: any): void {
    const avisoDC = this.dialog.open(AlertaConfirmDialog, {
      // width: '250px',
      disableClose: true,
      data: {
        tituloAlerta: "Aviso",
        textoAlerta:
          "Atenção este processi deletará permanentemente todos os treinos (mesociclos e microcilos). Confirma a exclusão deste Macrociclo? ",
        textoCancel: "Não",
        textoConfirm: "Sim",
        iconAlerta: "delete_forever",
      },
    });
    avisoDC.afterClosed().subscribe(
      (result) => {
        console.log(result);
        if (result == true) {
          this.hideCL = false;
          //criar no servidor
          let customParams = {
            //lista: localStorage.getItem('turboCart'),
            email: this.tmaService.hcEmail,
            senha: this.tmaService.hcSenha,
            idpaciente: this.idPaciente,
            idmacro: idMacro,
          };
          //var dadosU = 'email=' + this.tmaService.hcEmail + '&senha=' + this.tmaService.hcSenha + '&idpaciente=' + this.idPaciente;
          this.tmaService.excluirMacroT(customParams).subscribe((qRes) => {
            this.hideCL = true;
            if (qRes["res"] == "ok") {
              this.buscarDadosPaciente();
            } else {
              const erroCriar = this.dialog.open(AlertaSimplesDialog, {
                disableClose: true,
                data: {
                  textoAlerta:
                    "Ocorreu um erro ao criar ao excluir este macrociclo. Tente novamente",
                  iconAlerta: "warning",
                },
              });
            }
          });
        }
      },
      (error) => {
        this.hideCL = true;
        const erroCriar = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: {
            textoAlerta:
              "Verifique sua conexão com a internet. Tente novamente",
            iconAlerta: "warning",
          },
        });
      }
    );
  }

  addPlano(): void {
    this.router.navigate([
      "/dashboard/paciente/" + this.idPaciente + "/novo-plano",
    ]);
  }

  goTreino(idTreino: any): void {
    this.router.navigate([
      "dashboard/add-treino/" + this.idPaciente + "/" + idTreino,
    ]);
  }

  checkDesAli(idPlano: any): void {
    this.router.navigate([
      "dashboard/desempenho/" + this.idPaciente + "/" + idPlano,
    ]);
  }
  checkDesTre(idPlano: any): void {
    this.router.navigate([
      "dashboard/desempenho-treino/" + this.idPaciente + "/" + idPlano,
    ]);
  }

  checkAvali(idAvali: any): void {
    this.router.navigate([
      "dashboard/paciente/" + this.idPaciente + "/avaliacao/" + idAvali,
    ]);
  }

  goCompare() {
    this.router.navigate(["dashboard/comparacao/" + this.idPaciente]);
  }
  goPlanoAli(idPlano: any): void {
    this.router.navigate([
      "dashboard/refeicao/" + this.idPaciente + "/" + idPlano,
    ]);
  }

  goPlanoExc(idPlano: any): void {
    this.router.navigate([
      "dashboard/add-treino/" + this.idPaciente + "/" + idPlano,
    ]);
  }

  voltar(): void {
    console.log(this.tmaService.gUrlAnterior);
    if (this.tmaService.gUrlAnterior == "") {
      this.router.navigate(["/dashboard/home"]);
    } else {
      //this._location.back();
      this.router.navigate([this.tmaService.gUrlAnterior]);
      // if(this.tmaService.gUrlAnterior ==  'me/perfil'){
      //   this.router.navigate(['/home']);
      // }
      // else{
      //   this.router.navigate([ this.tmaService.gUrlAnterior]);
      // }
    }
  }
}
